import { actions } from 'react-redux-form';
import { httpGet, httpPost } from '../../../../../../utils/api.utils';
import { CIRCUIT_TYPES as CIRCUITTYPES, SUB_CIRCUIT_TYPES as SUBCIRCUITTYPES } from '../../../../../../utils/constant.utils';
import { getRequestUserSessionData as getUserData, isInteger } from '../../../../../../utils/helpers.utils';
import { getVendorDetails, getAddresses } from '../../../order-request.functions';

import {
    wirelineLocationModelA
    , wirelineSubscriptionModelA
    , wirelineBusinessModelA

    //ACTIONS
    , setCountryOptions
    , setAddressOptions
    , setVendorDetails
    , setVendorOptions
    , setCategoryOptions
    , setCircuitTypeOptions
    , setSubCircuitTypeOptions
    , setPrimarySecondaryOptions
    , setDefaultPrimarySecondary
    , setPurposeOfUseOptions
    , setFormSubmitted
} from './../../../../../../constants/model-reducers/external/request/wireline-request/new-circuit/new-circuit-subscription.settings';

export const wirelineLocationModelAInitialState = wirelineLocationModelA;
export const wirelineSubscriptionModelAInitialState = wirelineSubscriptionModelA;
export const wirelineBusinessModelAInitialState = wirelineBusinessModelA;

const defaultState = () => ({
    countryOptions: []
    , addressOptions: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , categoryOptions: []
    , circuitTypeOptions: []
    , subCircuitTypeOptions: []
    , primarySecondaryOptions: []
    , defaultPrimarySecondary: []
    , purposeOfUseOptions: []
    , vendorDetails: {
        Currency: ''
    }
    //, primaryPlanDetail: { ...planDetailConst }
    //, purposeOfUseOptions: []
    , formSubmitted: false
});

const initialState = defaultState();

export const newCircuitSubscriptionActions = {
    getNewCircuitFormData: () => async (dispatch, state) => {

        const { requestTypeId } = state().createRequest;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setCategoryOptions, data: res.ItemUses });
            dispatch({ type: setCircuitTypeOptions, data: res.CircuitTypes });
            dispatch({ type: setDefaultPrimarySecondary, data: res.PrimarySecondaryOptions });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
        }

    }
    //Location Actions
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));

        dispatch(actions.change('wirelineLocationFormA.locationAddressId', ''));
        dispatch(actions.change('wirelineLocationFormA.demarcLocation', ''));
        dispatch(actions.change('wirelineLocationFormA.locationAddressPTPId', ''));
        dispatch(actions.change('wirelineLocationFormA.demarcLocationPTP', ''));
        getAddresses(dispatch, setAddressOptions, value, true);
        getVendors(dispatch, state);

    }
    , onBillingAddressSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineLocationFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineLocationFormA.billingAddress', ''));
            dispatch(actions.change('wirelineLocationFormA.billingAddressId', null));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.LocationId != wirelineLocationFormA.billingAddressId) {
                dispatch(actions.change('wirelineLocationFormA.billingAddress', value));
                dispatch(actions.change('wirelineLocationFormA.billingAddressId', obj.LocationId));

            }
        }
    }
    // End Location Actions

    // Subscription Actions
    , onCategorySelect: (model, value) => async (dispatch, state) => {

        const { wirelineSubscriptionFormA } = state().form;
        let vendorId = wirelineSubscriptionFormA.vendorDetailId;
        dispatch(actions.reset('wirelineSubscriptionFormA'));
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormA.vendorDetailId', vendorId));

        getCircuitTypes(dispatch, value);
    }
    , onCircuitTypeSelect: (model, value) => async (dispatch, state) => {
        
        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelineSubscriptionFormA.subCircuitTypeId', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.primarySecondaryId', 0));
        getSubCircuitTypes(dispatch, value);
        updatePrimarySecondaryOptions(dispatch, state, value, CIRCUITTYPES);

    }
    , onChangeSubCircuitType: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));
        updatePrimarySecondaryOptions(dispatch, state, value, SUBCIRCUITTYPES);
    }
    , onChangePrimarySecondary: (model, value) => async (dispatch, state) => {
        dispatch(actions.change(model, value));

        dispatch(actions.change('wirelineSubscriptionFormA.btn', ''));
        dispatch(actions.change('wirelineSubscriptionFormA.btnId', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.mrc2', 0));
        dispatch(actions.change('wirelineSubscriptionFormA.nrc2', 0));
        const { wirelineSubscriptionFormA } = state().form;
        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseInt(wirelineSubscriptionFormA.mrc, 10) + parseInt(wirelineSubscriptionFormA.nrc, 10) + 0 + 0));
    }
    , onBTNSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineSubscriptionFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineSubscriptionFormA.btn', ''));
            dispatch(actions.change('wirelineSubscriptionFormA.btnId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineSubscriptionFormA.btnId) {
                dispatch(actions.change('wirelineSubscriptionFormA.btn', value));
                dispatch(actions.change('wirelineSubscriptionFormA.btnId', obj.CircuitId));

            }
        }
    }
    // End Subscription Actions

    // Start Business Actions
    , onApproverSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormA.wireLineApprover', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineApproverId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.EmployeeId != wirelineBusinessFormA.wireLineApproverId) {
                dispatch(actions.change('wirelineBusinessFormA.wireLineApprover', value));
                dispatch(actions.change('wirelineBusinessFormA.wireLineApproverId', obj.EmployeeId));
            }
        }
    }
    , onGLCodeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormA.wireLineGlCode', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineGlCodeId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.GlcodeId != wirelineBusinessFormA.wireLineGlCodeId) {
                dispatch(actions.change('wirelineBusinessFormA.wireLineGlCode', value));
                dispatch(actions.change('wirelineBusinessFormA.wireLineGlCodeId', obj.GlcodeId));
            }
        }
    }
    , onDateSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === undefined || value === '') {
            dispatch(actions.change('wirelineBusinessFormA.needByDate', ''));
          /*  dispatch(actions.change('wirelineBusinessFormA.needByDate', 0));*/
        } else {
            //var obj = objects.find(o => o[propsName] === value);
            //if (obj != null && obj.needByDate != wirelineBusinessFormA.needByDate) {
               
            //}
            dispatch(actions.change('wirelineBusinessFormA.needByDate', value));
           /* dispatch(actions.change('wirelineBusinessFormA.needByDateId', value));*/
        }
    }
    , onCostCenterSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineBusinessFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenter', ''));
            dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenterId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CostCodeId != wirelineBusinessFormA.wireLineGlCodeId) {
                dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenter', value));
                dispatch(actions.change('wirelineBusinessFormA.wireLineCostCenterId', obj.CostCodeId));
            }
        }
    }
    , onChangeMRC: (model,value) => (dispatch, state) => {

        dispatch(actions.change(model, value));

        if (!isInteger(value)) {
            value = 0;
        }

        const { wirelineSubscriptionFormA } = state().form;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseInt(value, 10) + parseInt(wirelineSubscriptionFormA.nrc, 10) + parseInt(wirelineSubscriptionFormA.mrc2, 10) + parseInt(wirelineSubscriptionFormA.nrc2, 10)));
    }
    , onChangeNRC: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));

        if (!isInteger(value)) {
            value = 0;
        }

        const { wirelineSubscriptionFormA } = state().form;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseInt(wirelineSubscriptionFormA.mrc, 10) + parseInt(value, 10) + parseInt(wirelineSubscriptionFormA.mrc2, 10) + parseInt(wirelineSubscriptionFormA.nrc2, 10)));
    }
    , onChangeMRC2: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));

        if (!isInteger(value)) {
            value = 0;
        }

        const { wirelineSubscriptionFormA } = state().form;


        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseInt(wirelineSubscriptionFormA.mrc, 10) + parseInt(wirelineSubscriptionFormA.nrc, 10) + parseInt(value, 10) + parseInt(wirelineSubscriptionFormA.nrc2, 10)));
    }
    , onChangeNRC2: (model, value) => (dispatch, state) => {

        dispatch(actions.change(model, value));

        if (!isInteger(value)) {
            value = 0;
        }

        const { wirelineSubscriptionFormA } = state().form;

        dispatch(actions.change('wirelineSubscriptionFormA.totalCost', parseInt(wirelineSubscriptionFormA.mrc, 10) + parseInt(wirelineSubscriptionFormA.nrc, 10) + parseInt(wirelineSubscriptionFormA.mrc2, 10) + parseInt(value, 10)));
    }

    // End Business Actions

    , submitRequest: (date) => async (dispatch, state) => {

        const { requestTypeId, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { wirelineLocationFormA
            , wirelineSubscriptionFormA
            , wirelineBusinessFormA

            , wirelessSubscriptionFormA
            , wirelessBusinessFormA
        } = state().form;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            // this block is temporary so that request will not fail (need refactor on the backend)
            LocationOrderModel: { isWirelineRequest: isWirelineRequest }
            , SubscriptionModel: { ...wirelessSubscriptionFormA }
            , BusinessJustificationModel: { ...wirelessBusinessFormA }
            // end

            , WirelineLocationModel: { ...wirelineLocationFormA }
            , WirelineSubscriptionModel: { ...wirelineSubscriptionFormA }
            , WirelineBusinessModel: {
                ...wirelineBusinessFormA
                , needByDate: date
            }
            , User: { ...userData }
            , NoEmail: false
            , RequestTypeId: requestTypeId
            , OrderRequestAutoApproved: true
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/orderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , resetNewCircuitForm: () => (dispatch) => {
        resetForm(dispatch);
    }
}

function resetForm(dispatch) {

    dispatch(actions.reset('wirelineLocationFormA'));
    dispatch(actions.reset('wirelineSubscriptionFormA'));
    dispatch(actions.reset('wirelineBusinessFormA'));
    dispatch({ type: setFormSubmitted, data: false });

}

function updatePrimarySecondaryOptions(dispatch, state, value, types) {

    const { defaultPrimarySecondary } = state().newCircuitRequest;

    if ((Object.values(types).indexOf(parseInt(value)) > -1)) {
        dispatch({ type: setPrimarySecondaryOptions, data: defaultPrimarySecondary });
    } else {
        dispatch({ type: setPrimarySecondaryOptions, data: defaultPrimarySecondary.slice(0, 2) });
    }

}

async function getVendors(dispatch, state) {

    const { isWirelineRequest } = state().createRequest;
    const { wirelineLocationFormA } = state().form;

    var data = {
        ...wirelineLocationFormA
        , IsWirelineRequest: isWirelineRequest
    };

    var res = await httpPost('external/orderRequest/getVendors', data);
    if (res.ok == undefined && res.PrefVendors.length > 0) {
        dispatch({
            type: setVendorOptions
            , prefVendors: res.PrefVendors
            , nonPrefVendors: res.NonPrefVendors
        });
        if (res.PrefVendors[0].Key != 0) {
            dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', res.PrefVendors[0].Key));
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, res.PrefVendors[0].Key);
        }
    }
}

async function getSubCircuitTypes(dispatch, value) {

    var res = await httpGet('external/orderRequest/getSubCircuitTypes/' + value);

    if (res != null) {
        dispatch({ type: setSubCircuitTypeOptions, data: res });
    } else {
        dispatch({ type: setSubCircuitTypeOptions, data: res });
    }
    return res != null;
}

async function getCircuitTypes(dispatch, value) {
    var res = await httpGet('external/orderRequest/getCircuitTypes/' + value);
    if (res != null) {
        dispatch({ type: setCircuitTypeOptions, data: res });
    } else {
        dispatch({ type: setCircuitTypeOptions, data: res });
    }
    return res != null;
}


export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state,
                addressOptions: action.data
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setCategoryOptions:
            return {
                ...state,
                categoryOptions: action.data
            };
        case setCircuitTypeOptions:
            return {
                ...state,
                circuitTypeOptions: action.data
            };
        case setSubCircuitTypeOptions:
            return {
                ...state,
                subCircuitTypeOptions: action.data
            };
        case setPrimarySecondaryOptions:
            return {
                ...state,
                primarySecondaryOptions: action.data
            };
        case setDefaultPrimarySecondary:
            return {
                ...state,
                defaultPrimarySecondary: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        default: return state;
    }
}